var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88087 3.34993L1.07744 12.1632C1.03315 12.2077 1.00117 12.2639 0.98594 12.3242L0.0101637 16.2449C-0.0190246 16.3629 0.0156207 16.4884 0.101663 16.5745C0.166765 16.6397 0.255472 16.6758 0.346209 16.6758C0.374002 16.6758 0.402429 16.6724 0.430094 16.6654L4.34665 15.6884C4.40769 15.6732 4.46315 15.6413 4.50744 15.597L13.3116 6.78429L9.88087 3.34993ZM15.4926 2.14827L14.5127 1.16728C13.8577 0.511631 12.7162 0.512267 12.062 1.16728L10.8616 2.36894L14.2922 5.80317L15.4926 4.60152C15.8198 4.27414 16 3.83839 16 3.37496C16 2.91152 15.8198 2.47578 15.4926 2.14827Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextEdit);
export default __webpack_public_path__ + "static/media/TextEdit.09931c0e.svg";
export { ForwardRef as ReactComponent };